module.exports = __webpack_public_path__ + "img/close.36a4a5f5.svg";